import {
  Divider,
  Grid,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Typography,
} from "@material-ui/core";
import { Fragment, useMemo } from "react";
import { AddUserToApartmentButtonWithDialog } from "..";
import { QUERIES } from "../../../graphql";
import { Apartment } from "../../../graphql/models";
import { useSnackbarQuery } from "../../../hooks";
import { LoadWrapper } from "../load_wrapper";
import { RemoveUserFromApartmentButton } from "../remove_user_from_apartment_button";

type ApartmentOrApartmentId = Apartment | string;

export interface ApartmentGuestsEditorProps {
  apartment: ApartmentOrApartmentId;
  onGuestAdded?: () => void;
  onGuestRemoved?: () => void;
}

export function ApartmentGuestsEditor(props: ApartmentGuestsEditorProps) {
  // TODO: convert this do api call with fetch apartment details
  const { apartment, onGuestAdded, onGuestRemoved } = props;

  const id = useMemo(() => {
    if (typeof apartment === "string") {
      return apartment as string;
    } else {
      return apartment.id;
    }
  }, [apartment]);

  const { data, loading, error, refetch } = useSnackbarQuery(
    QUERIES.APARTMENT_INFO,
    {
      variables: {
        id,
      },
    }
  );
  const apartmentDoc = useMemo(() => {
    return data?.apartmentInfo as Apartment;
  }, [data]);

  const apartmentGuestsAndAdmins = useMemo(() => {
    return (apartmentDoc?.users ?? []).filter(
      (v) => v.id !== apartmentDoc?.owner?.id
    );
  }, [apartmentDoc]);

  const triggerOnGuestAdded = () => {
    onGuestAdded && onGuestAdded();
    refetch();
  };

  const triggerOnGuestRemoved = () => {
    onGuestRemoved && onGuestRemoved();
    refetch();
  };

  return (
    <LoadWrapper loading={loading || !apartmentDoc} error={error}>
      <Grid container spacing={3} xs={12}>
        <Grid item xs={12}>
          <Typography variant="h5">
            Appartamento {apartmentDoc?.code}
            {apartmentDoc?.owner && (
              <Fragment>
                <br />
                <Typography variant="caption">
                  Proprietario: {apartmentDoc?.owner?.name}
                </Typography>
              </Fragment>
            )}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12}>
          Ospiti:
          <List>
            {apartmentGuestsAndAdmins.map((v) => (
              <Fragment>
                <ListItem>
                  <ListItemText primary={`${v.name}`} />
                  <ListItemSecondaryAction>
                    <RemoveUserFromApartmentButton
                      variant="contained"
                      color="secondary"
                      apartmentId={apartmentDoc?.id}
                      userId={v.id}
                      onUserRemovedFromApartment={triggerOnGuestRemoved}
                    >
                      RIMUOVI OSPITE
                    </RemoveUserFromApartmentButton>
                  </ListItemSecondaryAction>
                </ListItem>
                <Divider />
              </Fragment>
            ))}
          </List>
          <AddUserToApartmentButtonWithDialog
            onAdd={triggerOnGuestAdded}
            apartment={apartmentDoc}
            variant="contained"
          >
            AGGIUNGI NUOVO OSPITE
          </AddUserToApartmentButtonWithDialog>
        </Grid>
      </Grid>
    </LoadWrapper>
  );
}
